import React from "react";
import styled from "styled-components";
import prizeWrapperBg from "../../../../../assets/images/Event-2025/bg-popup-prize-wrapper.png";
import { Modal } from "antd";
import Footer from "./components/Footer";
import "./index.scss";

function BasePopup({
  type,
  variant,
  backgroundImage,
  open,
  children,
  noteText,
  buttonText,
  noFooter = false,
  noFooterButton = false,
  className,
  onCancel,
  getContainer = false,

  handleActionBtn = () => {}
}) {
  return (
    <StyleModal
      onCancel={onCancel}
      open={open}
      backgroundImage={backgroundImage}
      variant={variant}
      type={type}
      centered
      getContainer={getContainer ? false : ""}
      footer={
        noFooter ? null : (
          <Footer
            type={type}
            variant={variant}
            noteText={noteText}
            buttonText={buttonText}
            noFooterButton={noFooterButton}
            handleActionBtn={handleActionBtn}
          />
        )
      }
      className={className}
    >
      {children}
    </StyleModal>
  );
}

export default BasePopup;

const StyleModal = styled(Modal)`
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  height: 680px;
  background-size: cover;
  border-radius: 20px;

  .prize-image-wrapper__bg{
    pointer-events: none;
  }

  & > div {
    height: 100%;
  }

  & * {
    font-family: "Poppins", sans-serif !important;
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: none !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    padding: 12px;
    .popup-content {
      margin-top: 60px;

      &__title {
        display: flex;
        flex-direction: column;
        align-items: center;

        &-text {
          font-size: 18px;
          color: #fff;
          text-align: center;
          .highlight {
            font-weight: bold;
          }
          & > span {
            font-weight: 300;
          }
        }
      }

      &__body {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .prize-super {
          display: flex;
          justify-content: center;
          gap: 27px;
          margin: 44px 0 44px 0;

          & .prize-image-wrapper {
            &__bg {
              width: 264px;
              height: 264px;
            }

            img {
              width: 140px;
              height: 140px;
            }
          }
        }

        .prize-image-wrapper {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 16px 0 16px 0;
          &.no-wrapper {
            margin-top: 36px;
          }

          & > img {
            position: relative;
            z-index: 2;
          }

          &__bg {
            position: absolute;
            background-image: url(${prizeWrapperBg});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 370px;
            height: 370px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1;
          }
        }

        .prize-text-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: none;
          .prize-text-normal {
            font-size: 20px;
            font-weight: 500;
            color: #fff;
            text-align: center;
            &.top {
              font-size: 20px;
            }

            .shrikhand {
              display: block;
            }
          }
        }

        .mission-cards {
          margin-top: 16px;

          .mission-card {
            & > div {
              gap: 8px;
            }
          }
        }
      }
    }

    .shrikhand {
      font-family: "Shrikhand", serif !important;
      font-weight: 400;
      font-style: normal;
      color: #fff;
      font-size: 33px;
      -webkit-text-stroke: 2px rgba(23, 110, 229, 1);
      text-shadow: 0 4px 1px rgba(7, 110, 198, 1);
      text-align: center;

      &.medium {
        font-size: 32px;
        -webkit-text-stroke: 1.5px rgba(23, 110, 229, 1);
      }

      &.small {
        font-size: 26px;
        -webkit-text-stroke: 1px rgba(23, 110, 229, 1);
      }

      @media (max-width: 486px) {
        font-size: 36px;

        &.medium {
          font-size: 28px;
        }

        &.small {
          font-size: 24px;
        }
      }

      @media (max-width: 425px) {
        font-size: 32px;

        &.medium {
          font-size: 26px;
        }

        &.small {
          font-size: 22px;
        }
      }

      @media (max-width: 370px) {
        font-size: 28px;

        &.medium {
          font-size: 22px;
        }

        &.small {
          font-size: 18px;
        }
      }

      @media (max-width: 325px) {
        font-size: 28px;

        &.medium {
          font-size: 20px;
        }

        &.small {
          font-size: 16px;
        }
      }
    }

    .no-shadow{
      -webkit-text-stroke: 0px !important;
    }
  }

  .ant-modal-close {
    color: white;
    background-color: rgba(0, 0, 0, 0.4);
    padding: 10px;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    top: 1em;
    right: 1em;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 576px) {
      width: 32px;
      height: 32px;
      top: 10px;
      right: 10px;
    }

    & > svg {
      font-size: 24px;
    }

    &:hover,
    &:active {
      color: white;
      background-color: rgba(0, 0, 0, 0.4);
    }
  }

  .ant-modal-footer {
    flex: 1;
    margin-top: 16px;
  }

  @media (max-width: 486px) {
    /* height: 650px; */
    .ant-modal-content {
      .popup-content {
        &__title {
          &-text {
            font-size: 18px;
          }
        }

        &__body {
          .prize-image-wrapper {
            img {
              width: 85%;
            }
          }
          .prize-text-wrapper {
            .prize-text-normal {
              font-size: 20px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 452px) {
    /* height: 600px; */
    .ant-modal-content {
      .popup-content {
        &__title {
          &-text {
            font-size: 16px;
          }
        }

        &__body {
          .prize-image-wrapper {
            img {
              width: 80%;
            }
          }
        }
      }
    }
  }

  @media (max-width: 425px) {
    height: 625px;

    .ant-modal-content {
      padding: 20px 10px;
      .popup-content {
        &__title {
          &-text {
            font-size: 14px;
          }
        }

        &__body {
          .prize-super {
            margin: 24px 0 24px 0;
          }
          .prize-text-wrapper {
            .prize-text-normal {
              font-size: 18px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 412px) {
    // height: 550px;

    .ant-modal-content {
      .popup-content {
        &__body {
          .prize-super {
            margin: 24px 0 24px 0;
            .prize-image-wrapper {
              img {
                width: 115px;
                height: 115px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 370px) {
    height: 580px;
    .ant-modal-content {
      padding: 16px 12px;
      .popup-content {
        &__body {
          .prize-super {
            margin: 24px 0 24px 0;
            .prize-image-wrapper {
              img {
                width: 115px;
                height: 115px;
              }
            }
          }

          .prize-image-wrapper {
            & > img {
              width: 65%;
            }
          }

          .prize-text-wrapper {
            .prize-text-normal {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 350px) {
    // height: 475px;

    .ant-modal-content {
      padding: 16px 12px;
      .popup-content {
        &__title {
          &-text {
            font-size: 12px;
          }
        }

        &__body {
          .prize-image-wrapper {
            img {
              width: 65%;
            }
          }
          .prize-super {
            margin: 24px 0 24px 0;
            .prize-image-wrapper {
              img {
                width: 70px;
                height: 70px;
              }
            }
          }
          .prize-text-wrapper {
            .prize-text-normal {
              font-size: 14px;
            }
          }
        }
      }
    }

    .ant-modal-close {
      top: 0.5em !important;
      right: 0.5em !important;
    }

    // .ant-modal-footer {
    //   margin-top: 8px;
    // }
  }

  @media (max-width: 325px) {
    height: 550px;
  }
`;
